import { render, staticRenderFns } from "./DashEditHeader.vue?vue&type=template&id=2fe6c778&scoped=true&"
import script from "./DashEditHeader.vue?vue&type=script&lang=js&"
export * from "./DashEditHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashEditHeader.vue?vue&type=style&index=0&id=2fe6c778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6c778",
  null
  
)

export default component.exports